// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__11BJg","menu":"Sidebar_menu__2hc0j","isActive":"Sidebar_isActive__KTfDf","menuItem":"Sidebar_menuItem__2ZTPu"};